import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  navBurgerOpen: false,
  submissionFiltersOpen: false,
};

const slice = createSlice({
  name: 'ui',
  initialState: initialState,
  reducers: {
    toggleNavBurger: (state, { payload }) => {
      state.navBurgerOpen = payload;
    },
    toggleSubmissionFilters: (state, { payload }) => {
      state.submissionFiltersOpen = payload;
    },
  },
  extraReducers: {},
});

export const { toggleNavBurger, toggleSubmissionFilters } = slice.actions;

export default slice.reducer;
